// cf. https://deck.gl/docs/api-reference/core/web-mercator-viewport
import { WebMercatorViewport } from "@deck.gl/core";

import type { ViewportType } from "~/lib/map/types";

export const getBoundsFromViewport = (viewport: ViewportType) => {
  const projection = new WebMercatorViewport({ ...viewport });
  const { height, width } = viewport;
  const [west, north] = projection.unproject([0, 0]);
  const [east, south] = projection.unproject([width, height]);

  return { north, south, east, west };
};
